export default __webpack_public_path__ + "media/zurb/img/events/wired/rebuilding/rebuilding-img2-8d1343032b6a8dd846df32ae6ab931f6.jpg";